const developmentsData = {
  "propertyMetrics": [
    //pret1
    { development: 'pokugara', phase: 'pret-stands', type: 'stand' },
    { development: 'pokugara', phase: 'pret-1', type: 'townhouse' },

    //pret2
    { development: 'pokugara', phase: 'pret-2', type: 'villa' },
    { development: 'pokugara', phase: 'pret-2', type: 'manor' },
    { development: 'pokugara', phase: 'pret-2', type: 'garden' },

    // Millennium
    { development: 'millennium', phase: 'block-1', type: 'studio' },
    { development: 'millennium', phase: 'block-1', type: '1-bed' },
    { development: 'millennium', phase: 'block-2', type: 'studio' },
    { development: 'millennium', phase: 'block-2', type: '1-bed' },
    { development: 'millennium', phase: 'block-3', type: 'studio' },
    { development: 'millennium', phase: 'block-3', type: '1-bed' },

    { development: 'millennium', phase: 'block-4', type: 'studio' },
    { development: 'millennium', phase: 'block-4', type: '1-bed' },
    { development: 'millennium', phase: 'block-4', type: '2-bed' },
    { development: 'millennium', phase: 'block-4', type: '3-bed' },
   





    //pomona
    { development: 'pomona', phase: '1A', type: 'stand' },
  ],
  "developments": [

    {
      "id": "dev001",
      "name":"pokugara",
      "companyName":"Pokugara Properties (Private) Limited",
      "address":{
         "street": "No. 17B Lomagundi & Second Street Mt Pleasant",
         "country":"Zimbabawe",
         "city":"Harare",
       } , 
      "bank":{
        "bank":"Ecobank",
        "accountName": "WestProp Holdings",
        "accountNumber":"5712000019923",
        "bankCode":"26000",
        "swiftCode":"ECOCZWHX"
      },
      "logo": 'https://cdn.westprop.com/PRE+-+Townhouses.png'
    },

    {
      "id": "dev002",
      "name":"millennium",
      "companyName":"Seatrite Properties (Private) Limited",
      "address":{
         "street": "No. 17B Lomagundi & Second Street Mt Pleasant",
         "country":"Zimbabawe",
         "city":"Harare",
       } ,
      "bank":{
        "bank":"Ecobank",
        "accountName": "WestProp Holdings",
        "accountNumber":"5712000019923",
        "bankCode":"26000",
        "swiftCode":"ECOCZWHX"
      },
      "logo": 'https://cdn.westprop.com/millenium-heights.png'     
    },
    {
      "id": "dev003",
      "name":"pomona",
      "companyName":"Pomona Properties (Private) Limited",
      "address":{
         "street": "No. 17B Lomagundi & Second Street Mt Pleasant",
         "country":"Zimbabawe",
         "city":"Harare",
       } ,
      "bank":{
        "bank":"Ecobank",
        "accountName": "WestProp Holdings",
        "accountNumber":"5712000019923",
        "bankCode":"26000",
        "swiftCode":"ECOCZWHX"
      },
      "logo": 'https://cdn.westprop.com/pomona-logo.png'     
    },
    {
      "id": "dev004",
      "name":"sunshine",
      "companyName":"Sunshine Developments (Private) Ltd",
      "address":{
         "street": "No. 17B Lomagundi & Second Street Mt Pleasant",
         "country":"Zimbabawe",
         "city":"Harare",
       } ,
      "bank":{
        "bank":"Ecobank",
        "accountName": "WestProp Holdings",
        "accountNumber":"5712000019923",
        "bankCode":"26000",
        "swiftCode":"ECOCZWHX"
      },
      "logo": 'https://cdn.westprop.com/the-hills.png'     
    },

  ]
}
export default developmentsData; 
